import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
    palette: {
        primary: {
            main: '#000000', // Sfondo nero
        },
        text: {
            primary: '#CFD8DC', // Grigio medio per il testo principasle
        },
        background: {
            default: '#000000', // Sfondo predefinito della pagina
        },
        spacing: 8,  // Impostazione della distanza tra gli elementi
    },
    typography: {
        fontFamily: 'Roboto, Arial, sans-serif', // Font globale
        h3: { //Come titolo per about me e contact
            color: 'white',
            mb: 2,
            mt: 2
        },
        h4: { //footer name
            color: 'white',
            fontWeight: 700,
            letterSpacing: '.2rem',
            height: '100%'
        },
        h6: { //footer copyright
            color: 'grey',
            fontSize: '14px',
            userSelect: 'none'
        },
        subtitle1: { //Homepage title
            color: 'white',
            marginBottom: 2,
            letterSpacing: '.3rem',
            fontSize: '1.2rem',
            textAlign: 'center'
        },
        subtitle2: { //Homepage subtitle
            color: 'white',
            textAlign: 'center'
        },
        body1: { //About me testo
            color: '#d6d6d6',
            textAlign: 'center'
        },
    },
    
});

export const formTheme = createTheme({
    palette: {
        primary: {
            main: '#CFD8DC', // Colore principale: grigio medio per bottoni e focus
        },
        secondary: {
            main: '#c2c2c2', // Colore secondario: grigio scuro
            contrastText: '#FFFFFF', // Testo nei bottoni secondari
        },
        text: {
            primary: '#CFD8DC', // Grigio medio per il testo principale
            secondary: '#c2c2c2', // Grigio più scuro per testo secondario
        },
        background: {
            default: '#000000', // Sfondo nero per il modulo
            paper: '#1C1C1C', // Sfondo dei contenitori (come Card o moduli)
        },
    },
    typography: {
        fontFamily: 'Roboto, Arial, sans-serif', // Font globale
        button: {
            textTransform: 'none', // Rimuove l'uppercase predefinito nei bottoni
            fontSize: '1rem',
        },
    },
    components: {
        MuiTextField: {
            styleOverrides: {
                root: {
                    '& .MuiInputBase-input': {
                        color: '#FFFFFF', // Testo all'interno dei campi
                    },
                    '& .MuiInputLabel-root': {
                        color: '#CFD8DC', // Colore delle etichette
                    },
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                            borderColor: '#90A4AE', // Colore del bordo
                        },
                        '&:hover fieldset': {
                            borderColor: '#CFD8DC', // Colore del bordo al passaggio del mouse
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#FFFFFF', // Colore del bordo quando è focalizzato
                        },
                    },
                },
            },
        },
    },
});
